import React, { FC } from 'react';
import DemographicItem from '../DemographicItem';
import { StyledDemographicsItemsContainer } from './components';
import { DemographicsItemsProps } from './types';

const DemographicsItems: FC<DemographicsItemsProps> = ({
  type,
  values,
  onDemographicSelected,
  onItemDragToggle,
}) => {
  return (
    <StyledDemographicsItemsContainer>
      {values.map((value, index) => (
        <DemographicItem
          item={value}
          type={type}
          key={index}
          onDemographicSelected={onDemographicSelected}
          onItemDragToggle={onItemDragToggle}
        />
      ))}
    </StyledDemographicsItemsContainer>
  );
};

export default DemographicsItems;
